import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { site as defaults } from '../data/site';
import { loadContent } from '../services/content';

const SiteContext = createContext({ site: defaults, reload: async () => {} });

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [error, setError] = useState('');

  async function reload() {
    try {
      setContent(await loadContent());
      setError('');
    } catch (reason) {
      setError(`Live edits unavailable: ${reason.message}`);
    }
  }

  useEffect(() => { reload(); }, []);

  const site = useMemo(() => ({
    ...defaults,
    images: { ...defaults.images, ...content.images },
    rooms: [
      ...defaults.rooms.map((room) => ({
        ...room,
        ...content[`room-${room.number}`],
        images: content[`room-${room.number}`]?.images?.length
          ? content[`room-${room.number}`].images
          : room.images,
        image: content[`room-${room.number}`]?.images?.[0] || room.image
      })),
      ...Object.keys(content)
        .map((key) => /^room-(\d+)$/.exec(key))
        .filter(Boolean)
        .map((match) => Number(match[1]))
        .filter((number) => !defaults.rooms.some((room) => room.number === number))
        .sort((first, second) => first - second)
        .map((number) => {
          const room = content[`room-${number}`];
          const images = Array.isArray(room.images) ? room.images : [];
          return {
            number,
            title: room.title || `Room ${number}`,
            image: images[0] || '',
            images,
            alt: `Guest room ${number} interior`,
            description: '',
            price: '',
            capacity: '',
            ...room,
            images,
            image: images[0] || ''
          };
        })
    ]
  }), [content]);

  return <SiteContext.Provider value={{ site, reload, error }}>{children}</SiteContext.Provider>;
}

export function useSiteContent() {
  return useContext(SiteContext);
}